module.exports = __webpack_public_path__ + "static/media/circle-grey.ed2a1dad.svg";